import { useState } from 'react';
import './SectionPicker.css';

export const SECTIONS = [
  {
    id: 'avatar_picker',
    label: 'Avatar picker',
    description: 'Browse available AI agents to interact with',
  },
  {
    id: 'screening',
    label: 'Screening',
    description: 'Checks experience, availability and basic fit',
  },
  {
    id: 'conceptual_qna',
    label: 'Conceptual Q&A',
    description: 'Checks theory and domain knowledge.',
  },
  {
    id: 'coding',
    label: 'Coding exercise',
    description: 'Hands-on coding tasks tailored for the role.',
  },
  {
    id: 'whiteboarding',
    label: 'White-boarding',
    description: 'Analytical challenges testing logic and efficiency.',
  },
  {
    id: 'proctoring',
    label: 'Proctoring capabilities',
    description: 'Ensures interview integrity with automated flags',
  },
];

export default function SectionPicker({ activeSection, onSelect, sections = SECTIONS }) {
  const [collapsed, setCollapsed] = useState(false);

  const handleCardClick = (sectionId) => {
    onSelect(sectionId);
    setCollapsed(true);
  };

  return (
    <div className={`section-picker ${collapsed ? 'collapsed' : 'expanded'}`}>
      {/* Header — always visible, toggles collapse */}
      <button
        className="picker-header"
        onClick={() => setCollapsed((c) => !c)}
        aria-expanded={!collapsed}
      >
        <span className="picker-header-label">Pick a demo to experience AI interviews</span>
        <span className={`picker-chevron ${collapsed ? 'up' : 'down'}`}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M4 6l4 4 4-4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      {/* Animated cards wrapper */}
      <div className="picker-cards-wrap">
        <div className="picker-cards-inner">
          <div className="picker-cards">
            {sections.map((sec) => (
              <button
                key={sec.id}
                className={`picker-card ${activeSection === sec.id ? 'active' : ''}`}
                onClick={() => handleCardClick(sec.id)}
              >
                <span className="picker-card-label">{sec.label}</span>
                <span className="picker-card-desc">{sec.description}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
